import { bootstrapApplication } from '@angular/platform-browser';
import { applicationConfig } from './app/application.config';
import { ApplicationComponent } from './app/application.component';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    // Check for specific conflicts that need cleanup
    const hasConflicts = registrations.some(reg => 
      reg.scope.includes('firebase-cloud-messaging-push-scope') ||
      reg.scope.includes('firebase-messaging-sw.js') && reg.scope !== window.location.origin + '/'
    );
    
    if (hasConflicts) {
      // Clean up only problematic service workers
      registrations.forEach(reg => {
        if (reg.scope.includes('firebase-cloud-messaging-push-scope') ||
            (reg.scope.includes('firebase-messaging-sw.js') && reg.scope !== window.location.origin + '/')) {
          reg.unregister();
        }
      });
      
      // Wait for cleanup, then register
      setTimeout(() => {
        registerServiceWorker();
      }, 500);
    } else {
      registerServiceWorker();
    }
  });
}

function registerServiceWorker() {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js', {
      scope: '/' // Force root scope
    })
    .catch((error) => console.error('Error al registrar el Service Worker:', error));
}
bootstrapApplication(ApplicationComponent, applicationConfig).catch((err) => console.error(err));
